export function FloatingSidebar({children}){
	return <div style={{position: 'sticky', top: '2rem'}}>
		{children}
	</div>;
}
